import type { FaireProductEntity } from "../../entity_types/product";

export const p_bzvoaigo2m: FaireProductEntity = {
  token: "p_bzvoaigo2m",
  type: "product",
  name: "Organic Fruit Bites: Pineapple & Passionfruit, 8-pack case",
  brandToken: "b_3suuhjvzxi",
  brandName: "Mavuno Harvest Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/4bc3c5bb1e466f00ff6f185bc659c1a240b6bc86f080d49b32be44fdfdadee89.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d1236bfd09a49e6c0ff24f5d62ad650c63a6254695ff04c73295ca39a026c55c.png",
    "https://cdn.faire.com/fastly/363092028a332fffa80b1436e140c9b394d3e9dd51f2112f1d983188b3165288.png",
    "https://cdn.faire.com/fastly/db4cc1ce94d04fe9e1671d6a46c24b7a3da34ca2dffeccf3bbdd7b48cefdee3d.png",
    "https://cdn.faire.com/fastly/6d6c7434377ab6849b9753affaabe7ef9b8659adf6f8529e29868c299ba6f016.png",
  ],
  priceDollars: 22.16,
  description:
    "Bright, Tangy, and Refreshing\n\n\n\nA vibrant pairing of sweet pineapple and zesty passionfruit makes these chewy fruit bites a refreshing tropical treat. Bursting with natural flavor, they’re a perfect snack for kids and adults alike.\n\n\n\nIngredients\n\n\n\n * Organic pineapple \n * Organic passionfruit \n * No preservatives \n * No added sugar \nWhy It Matters\n\n\nBy combining fruit grown in Ghana from sustainable sources, these bites celebrate diverse farming communities working with care for the land.\n",
  tags: [],
  msrpDollars: 37.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:26.245Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
